import { useQuery } from '@tanstack/react-query'
import type { ClinicRef } from '@/features/appointments/api'
import { useApi } from '@/lib/api-context'

/**
 * A ficha de saúde como a paciente a lê (docs/api/portal.md, `GET /portal/anamneses/:id`;
 * RN-POR-07): os blocos na ordem em que ela respondeu, os dados confirmados, a prova.
 */

export interface AnamnesisSummary {
  id: string
  clinic: ClinicRef
  completedAt: string
  procedureAtSendTime: { name: string } | null
  practitioner: { name: string } | null
  protocolNumber: string | null
  appointmentId: string | null
  isImported: boolean
}

export interface ReadingQuestion {
  shortLabel: string
  label?: string
  answerText: string
}

export interface ReadingSection {
  key: string
  name: string
  questions: ReadingQuestion[]
}

export interface Evidence {
  protocolNumber: string
  hash: string
  shortHash: string
  submittedAt: string
  device: string | null
  declaration: { version: string | null; text: string | null; acceptedAt: string | null }
}

export interface AnamnesisReading extends AnamnesisSummary {
  evidence: Evidence | null
  sections: ReadingSection[]
}

export const anamnesisKeys = {
  detail: (id: string) => ['portal', 'anamnesis', id] as const,
}

export function useAnamnesis(id: string) {
  const api = useApi()
  return useQuery({
    queryKey: anamnesisKeys.detail(id),
    queryFn: () => api.get<AnamnesisReading>(`/portal/anamneses/${id}`),
  })
}
